import { css } from '@emotion/css';
import { Button, ButtonProps } from '@material-ui/core';
import React from 'react';

export const ButtonAsPlainText = (props: ButtonProps) => {
  return (
    <Button
      color="primary"
      {...props}
      classes={{
        root: css({
          fontSize: 'inherit',
          lineHeight: 'inherit',
          padding: 0
        })
      }}
    />
  );
};
